export const EditIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        d="M7.33399 1.33203H6.00066C2.66732 1.33203 1.33398 2.66537 1.33398 5.9987V9.99871C1.33398 13.332 2.66732 14.6654 6.00066 14.6654H10.0007C13.334 14.6654 14.6673 13.332 14.6673 9.99871V8.66538"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6933 2.01155L5.43992 7.26489C5.23992 7.46489 5.03992 7.85823 4.99992 8.14489L4.71325 10.1516C4.60659 10.8782 5.11992 11.3849 5.84659 11.2849L7.85326 10.9982C8.13326 10.9582 8.52659 10.7582 8.73326 10.5582L13.9866 5.30489C14.8933 4.39822 15.3199 3.34489 13.9866 2.01155C12.6533 0.678215 11.5999 1.10488 10.6933 2.01155Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.93945 2.76562C10.3861 4.35896 11.6328 5.60563 13.2328 6.05896"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
